import isTaskDone from './isTaskDone'

/**
 * Aantal nog openstaande projectafspraken per project.
 *
 * Openstaand = niet afgevinkt. Bewust niet 'de datum ligt in de toekomst':
 * juist een afspraak waarvan de datum al geweest is en die niemand heeft
 * afgehandeld hoor je te blijven zien.
 *
 * AI-CONTEXT: See docs/features/deccos-projectafspraken.md
 *
 * @param {Array<{ProjectID?: string, Done?: boolean|string}>|null|undefined} tasks
 * @returns {Map<string, number>} ProjectID → aantal openstaande afspraken
 */
const countOpenTasksByProject = (tasks) => {
    const counts = new Map()

    if (!Array.isArray(tasks)) return counts

    tasks.forEach((task) => {
        const projectId = task?.ProjectID
        if (!projectId || isTaskDone(task)) return

        counts.set(projectId, (counts.get(projectId) || 0) + 1)
    })

    return counts
}

export default countOpenTasksByProject
